import { AbstractControl, ValidationErrors } from '@angular/forms';

export function frenchPhoneNumberValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;

  if (!value) {
    return null;
  }

  if (!value.startsWith('+33')) {
    return null;
  }

  const cleanedPhone = cleanPhone(value);

  if (cleanedPhone.length !== 9) {
    return { frenchPhoneInvalid: true };
  }

  return null;
}

export const cleanPhone = (value: string) => {
  let localPart = value
    .replace(/\s+/g, '')
    .replace(/[^+\d]/g, '')
    .replace(/^\+33/, '');

  if (localPart.startsWith('0')) {
    localPart = localPart.slice(1);
  }

  const result = localPart.replace(/\D/g, '');

  return result;
};
